/*
    Copyright (C) 2023 - LMS2MTX - Southwest Airlines
*/
import App from "../../frontend/App.js";
import PingLogin from "./PingLogin";
import { ACCESS_TOKEN_KEY } from "../Constants";

export function Login() {
  const accessToken = JSON.parse(
    sessionStorage.getItem(ACCESS_TOKEN_KEY) || "{}"
  );
  const currentTime = Math.round(new Date().getTime() / 1000);
  const expiredTokenTime = accessToken?.issuedAt + accessToken?.expiresIn;
  if (accessToken?.accessToken && currentTime < expiredTokenTime) {
    return <App />;
  } else {
    return <PingLogin />;
  }
}
